import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Car } from '../../models/car';

@Injectable({
  providedIn: 'root'
})
export class CarCommandsService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)

  updateCarTelemetry = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/update`, {});
  }

  unlockDoor = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/unlock-door`, {});
  }

  lockDoor = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/lock-door`, {});
  }

  enableEngine = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/enable-engine`, {});
  }

  enableEngineAndUnlockDoor = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/enable-engine-and-unlock-door`, {});
  }

  disableEngine = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/disable-engine`, {});
  }

  disableEngineAndLockDoor = (carID: string): Observable<Car> => {
    return this.http.post<Car>(`${this.baseUrl}/cars/${carID}/commands/disable-engine-and-lock-door`, {});
  }
}